/* ===== Подключение иконок ===== */
import { ReactComponent as gsm } from "../../assets/icons/ui/gsm.svg";
import { ReactComponent as many } from "../../assets/icons/ui/many.svg";
import { ReactComponent as clock } from "../../assets/icons/ui/clock.svg";
import { ReactComponent as file } from "../../assets/icons/ui/file.svg";
import { ReactComponent as horse } from "../../assets/icons/ui/horse.svg";
import { ReactComponent as live } from "../../assets/icons/ui/live.svg";


const advantageCards = {
    id: "problems",
    grid: { cols: { base: 1, sm: 2, lg: 3 }, gap: "var(--spacing-4)" },
    items: [
        {
            id: "advantage-1",
            type: "advantage",
            Icon: gsm,
            title: "Сертифицированное топливо Евро-5",
            text: "Каждая поставка сопровождается паспортом качества производителя."
        },
        {
            id: "advantage-2",
            type: "advantage",
            Icon: many,
            title: "Честные цены (минимальная наценка)",
            text: "Благодаря отсутствию посредников наши цены конкурентны. Вы экономите бюджет, покупая топливо по справедливой стоимости без скрытых накруток.",
        },
        {
            id: "advantage-3",
            type: "advantage",
            Icon: clock,
            title: "Доставка за 24 часа Оперативная логистика",
            text: "Привезём топливо уже на следующий день после заявки. Это минимизирует ваши складские запасы и предотвращает простои – техника всегда заправлена вовремя. ",
        },
        {
            id: "advantage-4",
            type: "advantage",
            Icon: file,
            title: "Гибкий график поставок",
            text: "Предлагаем как разовые поставки, так и долгосрочные договоры с поставками по графику. Подстраиваемся под ваш производственный цикл хоть ежедневно, хоть раз в месяц – по вашему запросу.",
        },
        {
            id: "advantage-5",
            type: "advantage",
            Icon: horse,
            title: "Персональный менеджер 24/7",
            text: "За каждым клиентом закрепляется личный менеджер, который знает специфику вашего бизнеса. Вы всегда на связи с ответственным лицом, готовым решить любой вопрос – от оформления документов до экстренной дозаправки.",
        },
    ],
};

export default advantageCards;





